package org.gymly.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.Notifications
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.gymly.theme.GymlyColors
import org.gymly.theme.GymlySpace

@Composable
fun LanguageToggle(
    langEs: Boolean,
    onLangEs: (Boolean) -> Unit,
    light: Boolean = false,
) {
    val track = if (light) Color.White.copy(alpha = 0.9f) else GymlyColors.Outline.copy(alpha = 0.28f)
    Row(
        Modifier
            .clip(RoundedCornerShape(20.dp))
            .background(track)
            .padding(3.dp),
    ) {
        LangChip("EN", !langEs, light) { onLangEs(false) }
        LangChip("ES", langEs, light) { onLangEs(true) }
    }
}

@Composable
private fun LangChip(label: String, selected: Boolean, light: Boolean, onClick: () -> Unit) {
    Text(
        label,
        color = when {
            selected -> GymlyColors.OnPrimary
            light -> GymlyColors.Primary
            else -> GymlyColors.TextMuted
        },
        fontSize = 12.sp,
        fontWeight = FontWeight.SemiBold,
        modifier = Modifier
            .clip(RoundedCornerShape(16.dp))
            .background(if (selected) GymlyColors.Primary else Color.Transparent)
            .clickable(onClick = onClick)
            .padding(horizontal = 10.dp, vertical = 4.dp),
    )
}

@Composable
fun NotificationBell(
    unreadCount: Long,
    onClick: () -> Unit,
    tint: Color = GymlyColors.Text,
) {
    Box {
        IconButton(onClick = onClick) {
            Icon(Icons.Outlined.Notifications, contentDescription = "Notificaciones", tint = tint)
        }
        if (unreadCount > 0) {
            Box(
                Modifier
                    .align(Alignment.TopEnd)
                    .padding(top = 10.dp, end = 10.dp)
                    .size(8.dp)
                    .clip(CircleShape)
                    .background(Color(0xFFE53935)),
            )
        }
    }
}

/**
 * Cabecera móvil: título + campana. El idioma se toma del usuario actual.
 */
@Composable
fun MobilePageHeader(
    title: String,
    subtitle: String? = null,
    unreadCount: Long,
    langEs: Boolean,
    onLangEs: (Boolean) -> Unit,
    onBell: () -> Unit,
) {
    Column(Modifier.fillMaxWidth().padding(horizontal = GymlySpace.md, vertical = GymlySpace.sm)) {
        Row(
            Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Text(title, fontWeight = FontWeight.Bold, fontSize = 28.sp, color = GymlyColors.Text)
            NotificationBell(unreadCount = unreadCount, onClick = onBell)
        }
        if (!subtitle.isNullOrBlank()) {
            Text(
                subtitle,
                color = GymlyColors.TextMuted,
                fontSize = 13.sp,
                modifier = Modifier.padding(top = 6.dp, end = 8.dp),
            )
        }
    }
}

@Composable
fun MobileBlueHeader(
    greeting: String,
    subtitle: String,
    unreadCount: Long,
    langEs: Boolean,
    onLangEs: (Boolean) -> Unit,
    onBell: () -> Unit,
) {
    Column(
        Modifier
            .fillMaxWidth()
            .background(GymlyColors.Primary)
            .padding(horizontal = GymlySpace.md, vertical = GymlySpace.lg),
    ) {
        Row(
            Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.Top,
        ) {
            Column(Modifier.weight(1f).padding(end = 12.dp)) {
                Text(greeting, color = Color.White, fontWeight = FontWeight.Bold, fontSize = 26.sp)
                Text(subtitle, color = Color.White.copy(alpha = 0.85f), fontSize = 14.sp, modifier = Modifier.padding(top = 4.dp))
            }
            NotificationBell(unreadCount = unreadCount, onClick = onBell, tint = Color.White)
        }
    }
}
